import { Routes } from '@angular/router';
import { authGuardGuard } from '../guards/auth-guard.guard';

export const layoutRoutes: Routes = [
  {
    path: 'app',
    loadComponent: () => import('./main-layout/main-layout.component').then(m => m.MainLayoutComponent),
    canActivate: [authGuardGuard],
    children: [
      {
        path: 'my-profile',
        title: 'My Profile - Mosaic',
        loadComponent: () => import('./profile/profile.component').then(m => m.ProfileComponent)
      },
      {
        path: 'settings',
        title: 'Settings - Mosaic',
        loadComponent: () => import('./settings/settings.component').then(m => m.SettingsComponent)
      }
    ]
  }
];
